import { useEffect, useState } from 'react'

const useLocalStorage = (
  key,
  initialValue,
  force = false,
  resetOnMount = false,
) => {
  const [data, setData] = useState(
    force
      ? initialValue
      : resetOnMount
        ? initialValue
        : localStorage.getItem(key) || initialValue,
  )
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(data))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return [JSON.parse(data), setData]
}

export default useLocalStorage
